import { BuProfileConstant } from "presentation/constant/BuProfile/BuProfileConstant";
import { useBuProfileVM } from "presentation/hook/BuProfile/useBuProfileVM";
import { useBuProfileTracked } from "presentation/store/BuProfle/BuProfileProvider";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useCallback } from "react";
import { FieldType, HPHButton, IFieldValue } from "veronica-ui-component/dist/component/core";


const BuProfileRightEditPanel: React.FC = () => {
    const [buProfileState] = useBuProfileTracked();
    const buProfileVM = useBuProfileVM();
    const BUPROFILE_CONSTANT = BuProfileConstant.buProfile;
    const operatingCompany = buProfileState.currentOperatingCompany;

    const handleCancel = useCallback(() => {
        buProfileVM.onCancelCompanyEditPanel();
    }, [buProfileVM]);

    const addDataHandler = useCallback(() => {
        buProfileVM.addOperatingCompany();
    }, [buProfileVM]);

    const updateData = useCallback(() => {
        buProfileVM.updateOperatingCompany();
    }, [buProfileVM]);

    return <div className='sidebar' style={{ width: "30%" }}>
        <div className='sidebar-header'>
            <div className='sidebar-title'>
                {!buProfileState.isAddOperatingCompany ? operatingCompany.operatingCompany : "Add Company"}
                <span className='sidebar-caption'>All fields are required unless indicated as 'optional'</span>
            </div>
        </div>

        <div className='inner-div' style={{ width: "300px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={operatingCompany.operatingCompany || ''}
                fieldValue={operatingCompany.operatingCompany}
                fieldLabel={BUPROFILE_CONSTANT.COMPANY_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'operatingCompany'}
                maxLength={5}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    buProfileVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        <div className='inner-div' style={{ width: "300px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={operatingCompany.operatingCompanyName || ''}
                fieldValue={operatingCompany.operatingCompanyName}
                fieldLabel={BUPROFILE_CONSTANT.COMPANY_NAME}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'operatingCompanyName'}
                maxLength={200}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    buProfileVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        <div className='inner-div' style={{ width: "300px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={operatingCompany.operatingCompanyNameAbbr || ''}
                fieldValue={operatingCompany.operatingCompanyNameAbbr}
                fieldLabel={BUPROFILE_CONSTANT.DOC_ABBR}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'operatingCompanyNameAbbr'}
                maxLength={30}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    buProfileVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>

        <div className='sidebar-action-bar'>
            <HPHButton label={'Cancel'} size={'Small'} theme={'Secondary'} onClick={handleCancel} />
            {buProfileState.isAddOperatingCompany ?
                <HPHButton label={'Add'} size={'Small'} theme={'Primary'} onClick={addDataHandler} />
                :
                <HPHButton label={'Update'} size={'Small'} theme={'Primary'} onClick={updateData} />
            }
        </div>
    </div>
}

export default (BuProfileRightEditPanel);